import { WhatifRunsPage } from '@/pages/what-if/runs'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/whatif/runs/')({
	component: WhatifRunsPage,
})
